<!--#region------- (Text,Number,Enum Selection,Audit) Type ----->
<ng-container
  (click)="onAddRule()"
  *ngIf="
    [
      'text',
      'number',
      'audit',
      'auditText',
      'auditNumber',
      'enum',
      'enumValue'
    ].includes(type)
  "
>
  <div
    class="tw-block tw-mt-[1px] tw-px-4 tw-py-2"
    [matMenuTriggerFor]="menu"
    #filterMenuBtn="matMenuTrigger"
  >
    <i
      class="mdi mdi-21px tw-cursor-pointer"
      [style.color]="'#8c96a2'"
      [ngClass]="{
        'mdi-filter-outline': status == 'empty',
        'mdi-filter text-blue': status == 'set'
      }"
    ></i>
  </div>

  <!--------------------- matMenu  ----------------------->
  <mat-menu #menu="matMenu" class="tw-py-1">
    <section
      class="tw-w-[220px] tw-p-5 mat-menu"
      [style]="type == 'enum' || type == 'enumValue' ? 'width: 280px' : ''"
      (click)="$event.stopPropagation()"
    >
      <!-- #region Comparison Item 1 -->
      <ng-container>
        <!-- #region Operators -->
        <!-- TODO Torbatian [(ngModel)]="+comparisonItem.operator -->
        <select
          class="form-select form-control tw-text-[12px]"
          aria-label="Default select example"
          [(ngModel)]="comparisonItem.operator"
          (click)="$event.stopPropagation()"
        >
          <!-- text operators -->
          <ng-container *ngIf="type == 'text' && !customOperators">
            <option
              *ngFor="let ComparisonOperator of textOperators"
              [value]="ComparisonOperator"
            >
              {{
                ComparisonOperatorEnumDisplay[ComparisonOperator] | translate
              }}
            </option></ng-container
          >

          <!-- enum operators -->
          <ng-container
            *ngIf="(type == 'enum' || type == 'enumValue') && !customOperators"
          >
            <option
              *ngFor="let ComparisonOperator of enumOperators"
              [value]="ComparisonOperator"
            >
              {{
                ComparisonOperatorEnumDisplay[ComparisonOperator] | translate
              }}
            </option></ng-container
          >

          <!-- number operators -->
          <ng-container *ngIf="type == 'number' && !customOperators">
            <option
              *ngFor="let ComparisonOperator of numberOperators"
              [value]="ComparisonOperator"
            >
              {{
                ComparisonOperatorEnumDisplay[ComparisonOperator] | translate
              }}
            </option>
          </ng-container>

          <!-- custom operators -->
          <ng-container *ngIf="customOperators">
            <option
              *ngFor="let ComparisonOperator of customOperators"
              [value]="ComparisonOperator"
            >
              {{
                ComparisonOperatorEnumDisplay[ComparisonOperator] | translate
              }}
            </option>
          </ng-container>

          <!-- audit Text operators -->
          <ng-container *ngIf="type == 'auditText' && !customOperators">
            <option
              *ngFor="let ComparisonOperator of auditTextOperators"
              [value]="ComparisonOperator"
            >
              {{
                ComparisonOperatorEnumDisplay[ComparisonOperator] | translate
              }}
            </option>
          </ng-container>

          <!-- audit Number operators -->
          <ng-container *ngIf="type == 'auditNumber' && !customOperators">
            <option
              *ngFor="let ComparisonOperator of auditNumberOperators"
              [value]="ComparisonOperator"
            >
              {{
                ComparisonOperatorEnumDisplay[ComparisonOperator] | translate
              }}
            </option>
          </ng-container>
        </select>
        <!-- #endregion -->

        <!-- #region input Value -->
        <div
          class="input-group tw-text-[13px] tw-mt-3"
          (click)="$event.stopPropagation()"
        >
          <!-- input text -->
          <input
            #searchInput
            [value]="comparisonItem?.value || null"
            *ngIf="
              type != 'number' &&
              type != 'enum' &&
              type != 'enumValue' &&
              type != 'auditNumber'
            "
            type="text"
            class="form-control tw-text-[12px] tw-text-right"
            [class]="dir == 'ltr' ? 'dir-ltr' : 'dir-rtl'"
            [placeholder]="'messages.searchText' | translate"
            (keydown)="submitWithEnter($event)"
          />

          <!-- input number -->
          <input
            #searchInput
            [value]="inputNumberValue || null"
            *ngIf="type == 'number' && !noNumberSeparator"
            type="text"
            [onlyNumbers]="true"
            class="form-control tw-text-[12px] tw-text-right"
            [class]="dir == 'ltr' ? 'dir-ltr' : 'dir-rtl'"
            numberSeparator
            [placeholder]="'messages.searchText' | translate"
            (keydown)="submitWithEnter($event)"
          />

          <input
            #searchInput
            [value]="comparisonItem?.value || null"
            *ngIf="type == 'number' && noNumberSeparator"
            type="text"
            [onlyNumbers]="true"
            class="form-control tw-text-[12px] tw-text-right"
            [class]="dir == 'ltr' ? 'dir-ltr' : 'dir-rtl'"
            [placeholder]="'messages.searchText' | translate"
            (keydown)="submitWithEnter($event)"
          />

          <!-- input auditNumber -->
          <input
            #searchInput
            [value]="comparisonItem?.value || null"
            *ngIf="type == 'auditNumber'"
            type="text"
            [onlyNumbers]="true"
            [class]="dir == 'ltr' ? 'dir-ltr' : 'dir-rtl'"
            class="form-control tw-text-[12px] tw-text-right"
            [placeholder]="'messages.searchText' | translate"
            (keydown)="submitWithEnter($event)"
          />
        </div>
        <!-- #endregion -->

        <!-- #region enum selection list -->
        <ng-container *ngIf="type == 'enum' || type == 'enumValue'">
          <div>
            <!-- search box -->
            <div class="tw-px-0" style="padding-left: 8px">
              <mat-form-field
                class="select-list__search tw-w-full"
                appearance="outline"
              >
                <mat-label>{{ "common.search" | translate }}</mat-label>
                <input matInput #searchEnumInput />
                <mat-icon class="dark:tw-text-gray-400" matSuffix
                  >search</mat-icon
                >
              </mat-form-field>
            </div>

            <!-- enum selection list  -->
            <div class="filter-selection-list enum-field-searcher tw-pl-2">
              <mat-selection-list
                class="tw-h-[150px]"
                [multiple]="true"
                multiple
              >
                <div>
                  <div *ngFor="let item of enumValues">
                    <mat-list-option
                      #option
                      [value]="item.key"
                      (click)="addOrRemoveEnumValue(option)"
                      [selected]="
                        selectedEnumValues.includes(item.key) ? true : false
                      "
                    >
                      <div
                        class="tw-mx-1 tw-text-wrap tw-leading-[16px]"
                        [innerHTML]="item.value"
                      ></div>
                    </mat-list-option>
                  </div>
                </div>
              </mat-selection-list>
            </div>
          </div>
        </ng-container>
        <!-- #endregion -->

        <!-- #region new Rule -->
        <div>
          <!-- add rule  -->
          <ng-container *ngIf="!isShowComparisonItem2 && type == 'number'">
            <div
              class="tw-w-full tw-flex-center tw-mt-3"
              (click)="onAddRule()"
              (click)="$event.stopPropagation()"
            >
              <a class="btn btn-light-blue btn btn-sm tw-flex-center tw-w-full">
                <i class="mdi mdi-plus-thick mdi-18px"></i>
                {{ "common.addRule" | translate }}
              </a>
            </div>
          </ng-container>

          <!-- remove rule  -->
          <ng-container *ngIf="isShowComparisonItem2">
            <div
              class="border-bottom-2 border-bottom-dotted tw-border-gray-300 tw-flex-center flex-column tw-mb-5 tw-mt-3 tw-pb-5 tw-w-full"
              (click)="$event.stopPropagation()"
              (click)="onRemoveRule(true)"
            >
              <a
                class="btn btn-light-danger btn btn-sm tw-flex-center tw-w-full"
              >
                <i class="mdi mdi-trash-can-outline mdi-18px"></i>
                {{ "common.removeRule" | translate }}
              </a>
            </div>
          </ng-container>
        </div>
        <!-- #endregion -->
      </ng-container>
      <!-- #endregion -->

      <!--#region ComparisonItem 2 -->
      <div [class.d-none]="!isShowComparisonItem2">
        <!-- TODO Torbatian  [(ngModel)]="+comparisonItem.operator -->
        <select
          class="form-select form-control tw-text-[12px]"
          aria-label="Default select example"
          [(ngModel)]="comparisonItem2.operator"
          (click)="$event.stopPropagation()"
        >
          <!-- number operators -->
          <ng-container>
            <option
              *ngFor="let ComparisonOperator of numberOperators"
              [value]="ComparisonOperator"
            >
              {{
                ComparisonOperatorEnumDisplay[ComparisonOperator] | translate
              }}
            </option>
          </ng-container>
        </select>

        <!-- value -->
        <div
          class="input-group tw-text-[13px] tw-mt-3"
          (click)="$event.stopPropagation()"
        >
          <!-- input number -->
          <input
            #searchInput2
            [value]="comparisonItem2?.value || null"
            *ngIf="!noNumberSeparator"
            type="text"
            [onlyNumbers]="true"
            class="form-control tw-text-[12px] tw-text-right"
            [class]="dir == 'ltr' ? 'dir-ltr' : 'dir-rtl'"
            numberSeparator
            [placeholder]="'messages.searchText' | translate"
            (keydown)="submitWithEnter($event)"
            (input)="onChangeInputNumber2($event)"
          />

          <input
            #searchInput2
            [value]="comparisonItem2?.value || null"
            *ngIf="noNumberSeparator"
            type="text"
            [onlyNumbers]="true"
            class="form-control tw-text-[12px] tw-text-right"
            [class]="dir == 'ltr' ? 'dir-ltr' : 'dir-rtl'"
            [placeholder]="'messages.searchText' | translate"
            (keydown)="submitWithEnter($event)"
            (input)="onChangeInputNumber2($event)"
          />
        </div>

        <div>
          <!-- remove rule  -->
          <ng-container *ngIf="isShowComparisonItem2">
            <div
              class="tw-w-full tw-flex-center tw-mt-3 tw-mb-5"
              (click)="onRemoveRule(false)"
            >
              <a
                class="btn btn-light-danger btn btn-sm tw-flex-center tw-w-full"
              >
                <i class="mdi mdi-trash-can-outline mdi-18px"></i>
                {{ "common.removeRule" | translate }}
              </a>
            </div>
          </ng-container>
        </div>
      </div>
      <!-- #endregion -->

      <!-- #region btns -->
      <div class="tw-mt-3 tw-flex tw-flex-center">
        <!-- delete -->
        <button
          mat-ripple
          class="btn btn-danger tw-ml-2 tw-w-[40%] tw-text-[12px]"
          (click)="clearItems()"
          [disabled]="this.status == 'empty'"
        >
          {{ "common.delete" | translate }}
        </button>

        <!-- submit -->
        <button
          mat-ripple
          class="btn tw-w-[60%] tw-text-[12px]"
          [themeColor]="'btn'"
          (click)="onSubmit()"
        >
          {{ "common.search" | translate }}
        </button>
      </div>
      <!-- #endregion -->
    </section>
  </mat-menu>
</ng-container>
<!-- #endregion -->

<!--#region ------ Boolean Type ------------------------------>
<ng-container *ngIf="type == 'boolean'">
  <select
    class="small-select tw-mx-4 tw-my-2"
    (change)="onChangeBooleanTypeSelectOption($event)"
    [matTooltip]="'common.searchFilter' | translate"
    [class.bg-blue]="comparisonItem?.value || null"
  >
    <option value="none">
      <span> {{ "common.all" | translate }}</span>
    </option>

    <option
      [selected]="comparisonItem?.value == 'false' ? 'selected' : ''"
      [value]="false"
    >
      <span> {{ "common.no" | translate }}</span>
    </option>

    <option
      [selected]="comparisonItem?.value == 'true' ? 'selected' : ''"
      [value]="true"
    >
      <span> {{ "common.yes" | translate }}</span>
    </option>
  </select>
</ng-container>
<!-- #endregion -->

<!--#region ------ Single Enum Select Type  ------------------>
<ng-container *ngIf="type == 'singleEnumSelect'">
  <select
    class="small-select tw-mx-4 tw-my-2"
    (change)="onSubmitSingleEnumSelector($event)"
    [matTooltip]="hasMatToolTip ? ('common.searchFilter' | translate) : ''"
    [class.bg-blue]="comparisonItem?.value || null"
  >
    <option *ngIf="hasSelectAll" [value]="'none'">
      {{ "common.all" | translate }}
    </option>
    <option
      *ngFor="let item of enumValues"
      [value]="type == 'singleEnumSelect' ? item.key : item.value"
    >
      {{ item.value }}
    </option>
  </select>
</ng-container>
<!-- #endregion -->

<!--#region ------ Date Type --------------------------------->

<ng-container *ngIf="type == 'date' || type == 'dateTime'">
  <div
    class="tw-block tw-mt-1 tw-px-4 tw-py-2"
    [matMenuTriggerFor]="menu"
    #filterMenuBtn="matMenuTrigger"
  >
    <i
      class="mdi mdi-21px tw-cursor-pointer"
      [style.color]="'#8c96a2'"
      [ngClass]="{
        'mdi-filter-outline': status == 'empty',
        'mdi-filter text-blue': status == 'set'
      }"
    ></i>
  </div>

  <mat-menu #menu="matMenu" class="tw-py-1">
    <section class="tw-w-[220px] p-5">
      <!--#region ------------------start Date -->
      <div (click)="$event.stopPropagation()" class="tw-relative">
        <i
          class="mdi mdi-calendar-arrow-left tw-mr-1 mdi-22px tw-z-50"
          [matTooltip]="'common.startDateSearch' | translate"
          (click)="startPicker.open()"
          style="position: absolute; left: 10px; top: 14px"
        ></i>

        <input
          type="text"
          [(ngModel)]="startDate"
          (dateChange)="onGetDate(startDate, ComparisonOperator.GreaterThan)"
          [placeholder]="'common.startDateSearch' | translate"
          class="tw-w-full"
          [matDatepicker]="startPicker"
          [class]="dir == 'ltr' ? 'dir-ltr' : 'dir-rtl'"
          [readonly]="isRequired"
          (click)="startPicker.open()"
          class="form-control x tw-text-[12px]"
        />

        <mat-datepicker #startPicker></mat-datepicker>

        <i
          *ngIf="this.startDate && !isRequired"
          class="mdi mdi-close tw-mr-1 mdi-22px text-danger"
          [matTooltip]="'common.delete' | translate"
          (click)="onRemoveDate(ComparisonOperator.GreaterThan)"
          style="position: absolute; left: 40px; top: 14px"
        ></i>
      </div>
      <!-- #endregion -->
      <!--#region ------------------start time -->
      <div class="tw-relative tw-mt-[2px]" *ngIf="type == 'dateTime'">
        <i
          class="mdi mdi-clock tw-mr-1 mdi-22px tw-z-50 tw-absolute tw-left-[10px] tw-top-[14px]"
          [matTooltip]="'common.startTimeSearch' | translate"
          (click)="startTimePicker.open()"
        ></i>
        <input
          [ngxTimepicker]="startTimePicker"
          [format]="24"
          [(ngModel)]="startTime"
          [placeholder]="'common.startTimeSearch' | translate"
          [class]="dir == 'ltr' ? 'dir-ltr' : 'dir-rtl'"
          class="form-control x tw-text-[12px] tw-w-full"
          type="text"
          (ngModelChange)="onGetDate(startDate, ComparisonOperator.GreaterThan)"
        />

        <ngx-material-timepicker
          #startTimePicker
          [appendToInput]="true"
          [defaultTime]="startTime"
          [cancelBtnTmpl]="cancelBtnTimePiker"
          [confirmBtnTmpl]="confirmBtnTimePiker"
        ></ngx-material-timepicker>

        <ng-template #cancelBtnTimePiker>
          <button [class]="'btn btn-light tw-w-[75px] tw-mx-1 '">
            {{ "common.cancel" | translate }}
          </button>
        </ng-template>
        <ng-template #confirmBtnTimePiker>
          <button [class]="'btn tw-w-[75px] tw-mx-1 ' + 'btn-primary'">
            {{ "common.confirm" | translate }}
          </button>
        </ng-template>

        <i
          *ngIf="this.startTime && !isRequired"
          class="mdi mdi-close tw-mr-1 mdi-22px text-danger"
          [matTooltip]="'common.delete' | translate"
          (click)="onRemoveTime(ComparisonOperator.GreaterThan)"
          style="position: absolute; left: 40px; top: 14px"
        ></i>
      </div>
      <!-- #endregion -->

      <!--#region ------------------end Date -->
      <div (click)="$event.stopPropagation()" class="tw-relative">
        <i
          class="mdi mdi-calendar-arrow-right tw-mr-1 mdi-22px"
          [matTooltip]="'common.endDateSearch' | translate"
          (click)="endPicker.open()"
          style="position: absolute; left: 10px; top: 14px"
        ></i>

        <input
          type="text"
          (dateChange)="onGetDate(endDate, ComparisonOperator.LessThan)"
          [(ngModel)]="endDate"
          [placeholder]="'common.endDateSearch' | translate"
          class="tw-w-full"
          [matDatepicker]="endPicker"
          [min]="startDate"
          [readonly]="isRequired"
          (click)="endPicker.open()"
          class="form-control x tw-mt-2 tw-text-[12px]"
          [class]="dir == 'ltr' ? 'dir-ltr' : 'dir-rtl'"
        />
        <mat-datepicker #endPicker></mat-datepicker>

        <i
          *ngIf="this.endDate && !isRequired"
          class="mdi mdi-close mdi-22px tw-mr-1 text-danger"
          [matTooltip]="'common.clear' | translate"
          (click)="onRemoveDate(ComparisonOperator.LessThan)"
          style="position: absolute; left: 40px; top: 14px"
        ></i>
      </div>
      <!-- #endregion -->

      <!--#region ------------------end time -->
      <div class="tw-relative tw-mt-[2px]" *ngIf="type == 'dateTime'">
        <i
          class="mdi mdi-clock tw-mr-1 mdi-22px tw-z-50 tw-absolute tw-left-[10px] tw-top-[14px]"
          [matTooltip]="'common.endTimeSearch' | translate"
          (click)="endTimePicker.open()"
        ></i>
        <input
          [ngxTimepicker]="endTimePicker"
          [format]="24"
          [(ngModel)]="endTime"
          [placeholder]="'common.endTimeSearch' | translate"
          [class]="dir == 'ltr' ? 'dir-ltr' : 'dir-rtl'"
          class="form-control x tw-text-[12px] tw-w-full"
          type="text"
          (ngModelChange)="onGetDate(endDate, ComparisonOperator.LessThan)"
        />

        <ngx-material-timepicker
          #endTimePicker
          [appendToInput]="true"
          [defaultTime]="endTime"
          [cancelBtnTmpl]="cancelBtnTimePiker"
          [confirmBtnTmpl]="confirmBtnTimePiker"
        ></ngx-material-timepicker>

        <ng-template #cancelBtnTimePiker>
          <button [class]="'btn btn-light tw-w-[75px] tw-mx-1 '">
            {{ "common.cancel" | translate }}
          </button>
        </ng-template>
        <ng-template #confirmBtnTimePiker>
          <button [class]="'btn tw-w-[75px] tw-mx-1 ' + 'btn-primary'">
            {{ "common.confirm" | translate }}
          </button>
        </ng-template>

        <i
          *ngIf="this.endTime && !isRequired"
          class="mdi mdi-close tw-mr-1 mdi-22px text-danger"
          [matTooltip]="'common.delete' | translate"
          (click)="onRemoveTime(ComparisonOperator.LessThan)"
          style="position: absolute; left: 40px; top: 14px"
        ></i>
      </div>
      <!-- #endregion -->

      <!-- #region -----------------btns -->
      <div class="tw-mt-3 tw-flex tw-flex-center">
        <!-- delete -->
        <button
          *ngIf="!isRequired"
          mat-ripple
          class="btn btn-danger tw-ml-2 tw-w-[40%] tw-text-[12px]"
          (click)="clearDateFilter()"
          [disabled]="this.status == 'empty'"
        >
          {{ "common.delete" | translate }}
        </button>

        <!-- submit -->
        <button
          mat-ripple
          class="btn tw-text-[12px]"
          [ngClass]="!isRequired ? 'tw-w-[60%]' : 'tw-w-full'"
          [themeColor]="'btn'"
          (click)="emitItems()"
        >
          {{ "common.search" | translate }}
        </button>
      </div>
      <!-- #endregion -->
    </section>
  </mat-menu>

  <!-- </div> -->
</ng-container>

<!-- #endregion -->
